__turbopack_context__.v({
  "container": "FundraiserVippsNumberDisplay-module-scss-module__knxZIa__container",
  "context": "FundraiserVippsNumberDisplay-module-scss-module__knxZIa__context",
  "number": "FundraiserVippsNumberDisplay-module-scss-module__knxZIa__number",
  "sum": "FundraiserVippsNumberDisplay-module-scss-module__knxZIa__sum",
});
